import React from 'react';
import {Tabs, Cell, Checkbox, Input} from 'zarm';
import Video from '@static/image/video.png';
import Audio from '@static/image/audio.png';
import {toUpperCaseHeader} from '@utils';
import request from '@utils/request';
import CheckCard from './CheckCard';
import {
  OKTreatment
} from '@wap/components';
import './index.less';

const {Panel} = Tabs;
class InspectionGlasses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      panelList: [],
      activeKey: 0,
    };
  }
  componentDidMount() {
    // this.examineRef.fetchPanelList();
    const {data} = this.props;
    const {nodeId, tenantId, examContent = {}} = data;
    const {whichTimes = 0, whichTimesName} = examContent;
    request
      .get('/form_designer/ok_treatment/ok_app/inspection_glasses', {
        nodeId,
        tenantId,
      })
      .then((result) => {
        // 默认选中的tab
        const activeKey = result.findIndex(
          (item) => item.whichTimes === whichTimes
        );
        const panelList = result.map((item) => {
          if (item.whichTimes === whichTimes) {
            let param = {
              ...examContent,
              whichTimes: whichTimes || item.whichTimes,
              whichTimesName: whichTimesName || item.whichTimesName,
            };
            if (Object.keys(examContent).length === 0) {
              param = {...item};
            }
            // return { ...examContent, whichTimes: whichTimes || item.whichTimes, whichTimesName: whichTimesName || item.whichTimesName };
            return {...param};
          }
          return item;
        });
        this.setState({panelList, activeKey: activeKey > 0 ? activeKey : 0});
      });
  }

  /**
   * 处理好的数据成传给保存提交
   * @returns
   */
  handleResult = () => {
    const value = this.examineRef.handleResult();
    const {
      examContent: {list = []},
    } = value;
    return {
      ...value,
      examContent: list[0] || {},
    };
  };

  /**
   * tab改变
   */
  onTableChange = (value) => {
    this.setState({activeKey: value});
  };

  /**
   * 值的改变
   * @param {*} value 指标项的value
   * @param {*} field 指标项的key
   * @param {*} type 指标项的type
   */
  onValueChange = (value, field, type) => {
    const {data} = this.state;
    // 处理数据值
    if (value instanceof Array) {
      value = value.join(',');
    }
    // 设置数据值
    data.examContent[field] = value;
    // 前缀
    const prefix = toUpperCaseHeader(type);
    // 如果是点击正常并且是选中那么要清除其他指标
    if (/^dataO[s, d]Condition$/.test(field) && value.length > 0) {
      // 清除对应数据
      ['Trichiasis', 'BulbarConjunctiva', 'CorneaAbnormal', 'OtherStr'].forEach(
        (suffix) => {
          data.examContent[`data${prefix}${suffix}`] = null;
        }
      );
    } else {
      data.examContent[`data${prefix}Condition`] = null;
    }

    this.setState({data});
  };

  /**
   * 媒体资源改变
   * @param {Object} record
   */
  onMediaChange = (record) => {
    const {data} = this.state;
    data.examFiles = record;
    this.setState({data});
  };
  /**
   * 引用OK镜处方
   */
  quoteTreament = (quoteData) => {
    console.log(quoteData, 'quoteData')
    this.examineRef.initData(quoteData);
  }

  render() {
    const {activeKey, panelList} = this.state;
    const {data, tenantId, patientId} = this.props;
    const {examContent = {}} = data;
    // const ifShow = panelList.length > 0;
    return (
      <>
        <OKTreatment tenantId={tenantId} patientId={patientId} showQuote quoteTreament={quoteData => this.quoteTreament(quoteData)} />
        <CheckCard
          // useWearGlassData={} // 是否显示试戴数据
          data={{...data, examContent: {list: [examContent || {}]}}}
          ref={(ref) => (this.examineRef = ref)}
          useKeyBoard={1} // 属性是否使用键盘输入
          isShowRemark={true}
        />
      </>
    );
  }
}

export default InspectionGlasses;
